import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonCard,
   IonCardSubtitle,
   IonCardHeader,
   IonCardTitle,
   IonCardContent,
   useIonRouter,
   IonLoading,
   useIonViewWillEnter
} from '@ionic/react';
import { RouteComponentProps } from "react-router-dom";

import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import PassCheckCtrl, { checkPasscode } from '../components/PassCheckCtrl';
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

interface NtkExData extends RouteComponentProps<{
    amount : string
    }> 
{} 

const NtkExchangePass : React.FC<NtkExData> = ({match}) => {

    const [passKey, setPassKey] = useState("-- -- --");
    const [sending, setSending] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        // check whether passcode is set or not
        checkPasscode(router);
    });

    const biometricSubmit = async (username : string, password : string) => {
        await exchangeSubmit(password);
    }

    const exchange = async () => {
        await exchangeSubmit(passKey);
    }

    const exchangeSubmit = async (pass : string) => {
        
        setShowLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            lock: pass,
            amount : match.params.amount
        };

        var server = new NServer();
        await server.sendForm("ntk_exchange", state);

        setShowLoading(false);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push('/ntkexsuccess/' + server.data.usd + "/" + server.data.ntoken, "back", "pop");
        }
    }

    return (
        <IonPage>
            <IonContent>
                <div id="main-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/wallet" /> 
                    </IonButtons>
                </IonToolbar>
                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                />
                <PassCheckCtrl onChange={setPassKey} onSubmit={exchange} onBiometric={biometricSubmit} />
            </IonContent>
        </IonPage>
    );
}

export default NtkExchangePass;